<template>
  <div class="container">
    <div class="description-korzyna row center-xs">
      <div class="description-korzyna-head row col-xs-12">
        <add-partner :class="{'col-xs-6': !isCourierEnrollment, 'col-xs-12': isCourierEnrollment}" />
        <add-couriers v-if="!isCourierEnrollment" />
      </div>
    </div>
  </div>
</template>

<script async>
import AddPartner from './AddPartner'
import { mapGetters } from 'vuex';
import AddCouriers from './AddCouriers.vue';

export default {
  name: 'Description',
  components: {
    AddPartner,
    AddCouriers
  },
  computed: {
    ...mapGetters({
      courierEnrollment: 'configs/getConfigCourierEnrollment',
      currentLocation: 'locations/getActiveLocation'
    }),

    isCourierEnrollment () {
      if (!this.currentLocation) {
        return true;
      }

      const isPresent = this.courierEnrollment.find(meta => meta.key === 'disable_courier_enrollment')
      return isPresent ? isPresent.value : false
    }
  }
}
</script>

<style lang="scss" scoped>
  .description-item-image-block{
    font-size: 36px;
    color: #11bb2e;
  }
  .reviews-wrap{
    overflow: auto;
    overflow-x: scroll;
    white-space: nowrap;

    .reviews-item{
      padding: 0 15px;
      display: inline-block;
      width: 70vw;
      text-align: center;
      white-space: normal;
      margin: 5px;
      border-radius: 10px;
      box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.08);
      background-color: #ffffff;
      @media (min-width: 769px) {
        width: 29%;
      }
      @media (min-width: 992px) {
        width: 29%;
      }
    }

    .reviews-text{
      line-height: 1.3em;
      max-height: 7.8em;
      overflow: hidden;
      min-height: 7.8em;
    }
    .reviews-text, .reviews-date{
      font-size: 14px;
      font-weight: 300;
    }
    .reviews-stars{
      color: #ffc21e;

    }
    .reviews-name{
      font-size: 16px;
      color: #333;
      margin-bottom: 10px;
    }

  }
  .text{
    font-size: 14px;
  }
  .text-in-image{
    position: absolute;
    left: 50px;
    top: 25px;
    @media (max-width: 990px) {
      top: 0;
    }
    @media (max-width: 768px) {
      left: 32%;
      top: 10px;
    }
    @media (max-width: 530px) {
      left: 20%;
    }
  }
  .image-info{
    margin-top: 20px;
    @media (max-width: 990px) {
      margin-top: 0;
    }
  }
  .info-block{
    display: flex;
    position: relative;
    /*@media (max-width: 990px) and (min-width: 767px) {*/
    /*  margin-left: 100px;*/
    /*}*/
    @media (max-width: 768px) {
      display: block;
    }

  }
  .description-korzyna {
    @media only screen and (max-width: 769px) {
      margin-top: 50px;
    }

    @media only screen and (max-width: 576px) {
      &-head {
        flex-wrap: nowrap;
        flex-direction: column;
      }
    }
  }

</style>
